(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soul-home-judgeme-slot"] && !Shopify.designMode) return;
  try {
    
  function formatSoulReviewDate(value) {
    if (!value) return '';

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) return '';

    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  }

  function truncateSoulReviewText(value) {
    const text = String(value || '').replace(/\s+/g, ' ').trim();

    if (text.length <= 190) return text;

    return `${text.slice(0, 187).trim()}...`;
  }

  function buildSoulReviewCard(review) {
    const card = document.createElement('article');
    const stars = document.createElement('span');
    const quote = document.createElement('blockquote');
    const footer = document.createElement('footer');
    const reviewer = document.createElement('strong');
    const context = document.createElement('span');
    const rating = Math.max(1, Math.min(5, Math.round(Number(review.rating) || 5)));
    const reviewDate = formatSoulReviewDate(review.created_at);
    const contextText = review.verified_buyer ? 'Compra verificada' : 'Avaliação verificada';

    card.className = 'soul-judgeme-slot__card';
    stars.className = 'soul-judgeme-slot__card-stars';
    stars.setAttribute('aria-label', `${rating} estrelas`);
    stars.textContent = '★★★★★'.slice(0, rating);
    quote.textContent = truncateSoulReviewText(review.body);
    reviewer.textContent = review.public_reviewer_name || review.reviewer_name || 'Cliente Fazenda Soul Leve';
    context.textContent = reviewDate ? `${contextText} - ${reviewDate}` : contextText;

    footer.append(reviewer, context);
    card.append(stars, quote, footer);

    return card;
  }

  async function loadLatestSoulJudgeMeReviews(section) {
    if (!section || section.dataset.soulJudgemeLoaded === 'true') return;

    const track = section.querySelector('[data-soul-judgeme-cards]');
    const limit = Number(section.dataset.reviewLimit) || 6;
    const shopDomain = section.dataset.shopDomain || window.Shopify?.shop;

    if (!track || !shopDomain) return;

    section.dataset.soulJudgemeLoaded = 'true';

    const apiBase =
      window.jdgm && window.jdgm.CDN_API_HOST
        ? `${window.jdgm.CDN_API_HOST.replace(/\/$/, '')}/`
        : 'https://cdn.judge.me/';
    const params = new URLSearchParams({
      reviews_selection: 'store_reviews',
      carousel_type: 'cards',
      star_rating: '4_to_5_star',
      max_reviews: String(limit),
      url: window.location.origin,
      shop_domain: shopDomain,
      platform: 'shopify',
      primary_language: document.documentElement.lang || 'pt-BR',
      display_order: 'most_recent',
    });

    try {
      const response = await fetch(`${apiBase}reviews/reviews_for_carousel?${params}`, {
        credentials: 'omit',
        cache: 'no-store',
      });
      const data = await response.json();
      const reviews = Array.isArray(data.reviews) ? data.reviews : [];
      const latestReviews = reviews
        .filter((review) => review && review.body)
        .sort((first, second) => new Date(second.created_at || 0) - new Date(first.created_at || 0))
        .slice(0, limit);

      if (!latestReviews.length) return;

      const fragment = document.createDocumentFragment();
      latestReviews.forEach((review) => fragment.appendChild(buildSoulReviewCard(review)));

      track.replaceChildren(fragment);
    } catch (error) {
      section.dataset.soulJudgemeLoaded = 'false';
    }
  }

  function initLatestSoulJudgeMeReviews(root = document) {
    root.querySelectorAll('[data-soul-judgeme-latest]').forEach(loadLatestSoulJudgeMeReviews);
  }

  function hideSoulEmptyJudgeMeCarousel() {
    const slot = document.querySelector('.soul-judgeme-slot');
    const slotSection = slot && slot.closest('.shopify-section');

    if (!slotSection) return;

    let nextSection = slotSection.nextElementSibling;
    let scannedSections = 0;

    while (nextSection && scannedSections < 4) {
      const carousel = nextSection.querySelector('.jdgm-cards-carousel');

      if (carousel) {
        nextSection.style.display = 'none';
        return;
      }

      nextSection = nextSection.nextElementSibling;
      scannedSections += 1;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initLatestSoulJudgeMeReviews();
    hideSoulEmptyJudgeMeCarousel();
  });

  document.addEventListener('shopify:section:load', () => {
    initLatestSoulJudgeMeReviews();
    window.setTimeout(hideSoulEmptyJudgeMeCarousel, 120);
  });

  initLatestSoulJudgeMeReviews();
  window.setTimeout(hideSoulEmptyJudgeMeCarousel, 250);
  window.setTimeout(hideSoulEmptyJudgeMeCarousel, 1400);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soul-home-trust"] && !Shopify.designMode) return;
  try {
    
  function initSoulHomeTrustCarousel(section) {
    if (!section || section.dataset.soulHomeTrustReady === 'true') return;

    const track = section.querySelector('[data-soul-home-trust-track]');
    const items = Array.from(section.querySelectorAll('.soul-home-trust__item'));
    const dots = Array.from(section.querySelectorAll('[data-soul-home-trust-dot]'));

    if (!track || items.length === 0 || dots.length === 0) return;

    section.dataset.soulHomeTrustReady = 'true';

    let frame = null;

    const setActiveDot = () => {
      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      let activeIndex = 0;
      let activeDistance = Infinity;

      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const distance = Math.abs(trackCenter - itemCenter);

        if (distance < activeDistance) {
          activeDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    };

    const requestSetActiveDot = () => {
      if (frame) return;

      frame = window.requestAnimationFrame(() => {
        setActiveDot();
        frame = null;
      });
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        items[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      });
    });

    track.addEventListener('scroll', requestSetActiveDot, { passive: true });
    window.addEventListener('resize', requestSetActiveDot);
    setActiveDot();
  }

  document.querySelectorAll('.soul-home-trust').forEach(initSoulHomeTrustCarousel);

  document.addEventListener('shopify:section:load', (event) => {
    initSoulHomeTrustCarousel(event.target.querySelector('.soul-home-trust'));
  });

  } catch(e) { console.error(e); }
})();
})();
